import Navbar from './Navbar.js'
import styles from './Home.module.css'

const Home = () => {
    return (
        <div className={styles.Home} >
            <Navbar />
            <main className={styles.homeMainCon}>
         
                <div className={styles.homeFirstCon}>
                    <h1>So You want to travel to <br /> <span>space</span></h1>
                    <p>Let's face it: if you want to go to space, you might as well genuinely go to outer-space and not hover kind of on the edge of it. Well sit back, and relax because we'll give you a truly out of this world experience!</p>
                   
                </div>
          
                <div className={styles.beforeHomeSecondCon}>
                    <div className={styles.homeSecondCon}>Explore</div>
                </div>
            </main>
        </div>
    );
}

export default Home;